import React from 'react';
import { useSearchParams } from 'react-router-dom';
import UltravoxVoiceInterface from '../components/voice/UltravoxVoiceInterface';

const VoiceOrderPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const tableNumber = searchParams.get('table');

  return (
    <div className="min-h-screen bg-gray-50 py-4">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <UltravoxVoiceInterface tableNumber={tableNumber || undefined} />
      </div>
    </div>
  );
};

export default VoiceOrderPage;